// Country calling codes for the phone-number auth fields.
// Add more entries here as needed — every consumer (LoginPage, SignupPage,
// PhoneInput, admin) reads from this single list.
export const COUNTRY_CODES = [
  { country: 'IN', code: '+91', name: 'India' },
  { country: 'US', code: '+1', name: 'United States' },
  { country: 'GB', code: '+44', name: 'United Kingdom' },
  { country: 'AE', code: '+971', name: 'United Arab Emirates' },
  { country: 'SG', code: '+65', name: 'Singapore' },
  { country: 'MY', code: '+60', name: 'Malaysia' },
  { country: 'AU', code: '+61', name: 'Australia' },
  { country: 'CA', code: '+1', name: 'Canada' },
  { country: 'DE', code: '+49', name: 'Germany' },
  { country: 'FR', code: '+33', name: 'France' },
];

export const DEFAULT_COUNTRY_CODE = '+91';

export const findCountryByCode = (code) =>
  COUNTRY_CODES.find((c) => c.code === code) || COUNTRY_CODES[0];
